import { PageSection } from 'components';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import {
    Container,
    Hexa,
    SpeakersButton,
} from '../../../for-businesses/components/speakers/styled';
import {
    Description,
    DescriptionWrapper,
    Title,
    Wrapper,
} from '../../../for-businesses/components/test/styled';

const sectionConfig = {
    CWrap: {
        css: {
            paddingTop: 300,
            paddingBottom: 50,
            background: '#3DE8CA',
            backgroundImage:
                'radial-gradient(ellipse farthest-corner at 92% 95%, #4DFF88, transparent 40%), radial-gradient(ellipse farthest-side at 10% 90%, #4DFF88, transparent 40%)',

            '@media(max-width: 1279px)': {
                backgroundImage: 'none',
            },

            '@media(max-width: 1023px)': {
                paddingTop: 120,
                paddingBottom: 0,
            },
        },
    },
    ContentArea: {
        css: {
            display: 'block',
            position: 'relative',
            zIndex: 2,
        },
    },
};

export const Test: FC = () => {
    const { t } = useTranslation('pages/for-schools-and-colleges');

    return (
        <Wrapper>
            <Hexa
                secondary
                image={
                    process.env.PUBLIC_URL +
                    '/assets/images/bussiness/hexa2.png'
                }
            />
            <PageSection config={sectionConfig}>
                <Container secondary>
                    <DescriptionWrapper>
                        <Title>{t('test-title')}</Title>
                        <Description>{t('test-description')}</Description>
                        <SpeakersButton
                            variant={'contained'}
                            color={'primary-contrast'}
                            size={'large'}
                            onClick={() =>
                                (window.location.href =
                                    'mailto:Academy@kaspersky.com')
                            }>
                            {t('connect-wth-us')}
                        </SpeakersButton>
                    </DescriptionWrapper>
                </Container>
            </PageSection>
        </Wrapper>
    );
};
